import { TaskType } from '../../../../core/entities/task/task-type';
import { gql } from 'apollo-angular';

export const GET_TASK_TYPES_QUERY = gql`
query getTaskTypes($filter: TaskTypeFilter){
  getTaskTypes(filter: $filter){
    code
    name
  }
}
`;

export interface GetTaskTypesResponse {
  getTaskTypes: TaskType[];
  loading: boolean;
}